/**
 * Modal
 */
const modal = document.querySelector(".oleu-modal");
const backdrop = document.querySelector(".oleu-modal-backdrop");
const closeModalBtn = document.querySelector(".oleu-modal__btn-close");
const btn = document.createElement("button");
const btnText = document.createTextNode("Size Chart");

// Wrapped in a timer and button created dynamically since event listener is
// removed if added at page load
setTimeout(function () {
  const btnWrapper = document.querySelector(".js-size-chart-link");
  btn.classList.add("size-chart-btn");
  btn.setAttribute("type", "button");
  btn.appendChild(btnText);
  if (btnWrapper) {
    btnWrapper.appendChild(btn);
  }
  // open modal
  btn.addEventListener("click", oleuOpenModal);
}, 1000);

// open modal function
const oleuOpenModal = function () {
  modal.classList.add("oleu-modal-show");
  backdrop.classList.add("oleu-modal-show");
  document.body.classList.add("oleu-modal-open");
};

// close modal function
const closeModal = function () {
  modal.classList.remove("oleu-modal-show");
  backdrop.classList.remove("oleu-modal-show");
  document.body.classList.remove("oleu-modal-open");
};

// close the modal when the close button and overlay is clicked
closeModalBtn.addEventListener("click", closeModal);
// document.addEventListener("click", function (e) {
//   const modalClick = modal.contains(e.target);
//   if (
//     e.target !== btn &&
//     document.body.classList.contains("oleu-modal-open") &&
//     !modalClick
//   ) {
//     console.log("click outside");
//     closeModal();
//   }
// });

// close modal when the Esc key is pressed
document.addEventListener("keydown", function (e) {
  if (
    e.key === "Escape" &&
    document.body.classList.contains("oleu-modal-open")
  ) {
    closeModal();
  }
});

/**
 * Uncheck initial size selection on PDP
 *
 * Forced attempt to un assign first selected variant.
 */
// setTimeout(function () {
//   const sizeOptions = document.querySelectorAll(
//     ".swatch-element.available:not(.color)"
//   );
//   const defaultSelection = document.getElementsByClassName(
//     "product-single__variants original-select"
//   );
//   let url = new URL(window.location.href);
//   if (sizeOptions.length && !url.searchParams.has("variant")) {
//     // uncheck size options
//     for (var i = 0; i < sizeOptions.length; i++) {
//       sizeOptions[i].querySelector("input").checked = false;
//     }
//     // unselect default variant selection
//     defaultSelection.value = "";
//   }
// }, 500);

// page load, get size and show
// size change

